import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7292a91e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-wrap wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, " ", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Export Search result")
const _hoisted_5 = {
  ref: "myChart",
  style: { width: '300px', height: '300px' }
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_space, {
        class: "feature-con",
        ref: "searchCon",
        align: "end"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_a_space, {
            size: 20,
            style: {"text-align":"right","margin-bottom":"5px"}
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_a_button, {
                onClick: _ctx.exportResult,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_5, null, 512)
    ])
  ], 64))
}